import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiSvgIcon = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiSvgIcon'];
  defaultProps?: ComponentsProps['MuiSvgIcon'];
  variants?: ComponentsVariants['MuiSvgIcon'];
};

export const MuiSvgIcon: MuiSvgIcon = {
  defaultProps: { fontSize: 'inherit', color: 'inherit' },
  styleOverrides: {
    root: {
      fontSize: 'inherit',
      color: 'inherit',
    },
  },
};
